// extracted by mini-css-extract-plugin
export default {"modalBodyStyle":"badgeModal_modalBodyStyle__sl1lg","modal":"badgeModal_modal__GDitp"};